export default {
    listagem: {
        table: {
            empty: "Nenhuma Trigger encontrada",
            nome: "Nome",
            novo: "Criar nova Trigger",
            regra: "Regra",
            acoes: "Ações",
            editar: "Editar",
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar nova Trigger',
            editar: 'Editar Trigger'
        },
        fields: {
            nome: {
                label: "Nome",
                description: "Qual será o nome da nova Trigger?"
            },
            condicao: {
                fields: {
                    firstField: {
                        label: "Campo",
                        description: "Qual será o campo para validar."
                    },
                    rule: {
                        label: "Condição",
                        description: "Qual será a condição."
                    },
                    secondField: {
                        label: "Valor",
                        description: "Qual será o valor para comparar."
                    },
                    thirdField: {
                        label: "Outro Valor",
                        description: "Qual será o outro valor para comparar."
                    }
                },
                DB_fields: {
                    exam_code: "Código do exame",
                    method_code: "Método do exame",
                    specimen_code: "Código da amostra",
                    value_quantity_value: "Valor do resultado",
                    reference_range_text: "Texto do intervalo de referência",
                    reference_range_structured: "Intervalo de referência estruturado",
                    parent_exam_code: "Código do exame pai"
                },
                rules: {
                    isNull: "Está vazio",
                    isNotNull: "Não está vazio",
                    bigger: "Maior que",
                    biggerOrEqual: "Maior ou igual a",
                    less: "Menor que",
                    lessOrEqual: "Menor ou igual a",
                    equal: "é igual a",
                    different: "é diferente de",
                    between: "Está entre",
                    notBetween: "Não está entre"
                }
            },
            action: {
                label: "Ação",
                description: "Qual será a ação tomada pelo sistema?",
                options: {
                    Blocked: "Bloquear o Exame",
                    Alert: "Alertar sobre o Exame"
                }
            }
        },
        buttons: {
            adicionar_condicao: 'Adicionar condição',
            remover_condicao: 'Remover condição',
            salvar: 'Salvar Trigger'
        },
        create: {
            success: "Trigger criada com Sucesso!",
            error: "Error ao criar Trigger!"
        },
        update: {
            success: "Trigger editada com Sucesso!",
            error: "Error ao editar Trigger!"
        }
    }
}
